import { useState, useEffect } from 'react'
import { getContactWhatAreYouLookingForTypes } from 'app/services/sfAuth/sfData/sfContact'

export type GoalOption = {
  label: string
  value: string
}

export const useGoalOption = () => {
  
  const [goalOptions, setGoalOptions] = useState<GoalOption[]>([])

  useEffect(() => {
    getContactWhatAreYouLookingForTypes().then((types) => {
      setGoalOptions(types)
    })
  }, [])

  return { goalOptions }

}